import { useMemo } from 'react';

import type { InvoiceInconsistencyItem } from 'src/core/modules/verification-of-payee/models';

import { type Transfer } from '../models';
import {
  groupTransfersByCounterparty,
  mapGroupedTransfersToInconsistencyItems,
} from '../utils';

export const useVerificationOfPayeeInconsistencyItems = (
  invalidVoPTransfers: Transfer[],
): InvoiceInconsistencyItem[] => {
  return useMemo((): InvoiceInconsistencyItem[] => {
    const groupedTransfers = groupTransfersByCounterparty(invalidVoPTransfers);
    return mapGroupedTransfersToInconsistencyItems(
      groupedTransfers,
      (counterpartyId) => {
        const invalidTransfer = invalidVoPTransfers.find(
          (transfer) => transfer.bill.counterparty.id === counterpartyId,
        );
        if (
          !invalidTransfer?.verificationOfPayee?.initialResult.matchingResult ||
          invalidTransfer.verificationOfPayee.initialResult.matchingResult ===
            'match'
        ) {
          throw new Error(
            'Verification of payee matching result should be defined here',
          );
        }
        return invalidTransfer.verificationOfPayee.initialResult.matchingResult;
      },
    );
  }, [invalidVoPTransfers]);
};
